module.exports = __webpack_public_path__ + "static/media/password-icon.4ecea6fb.svg";